import { makeApiRequest } from '@/src/lib/api-request'
import { useToken } from '@/src/store/token-store'
import { useUser } from '@/src/store/user-store'
import { useQuery } from '@tanstack/react-query'

export interface VideoDetailsDto {
  eventId: string
  userId: string
  type: string
  duration: string
  priceType: string
  eventName: string
  eventTitle: string
  eventContent: string
  watchCount: string
  commentCount: string
  eventEntryDate: string
  UniqueWatchTime: string
  likeCount: string
  dislikeCount: string
  firstName: string
  imageUrl: string
  channelName: string
  channelShareName: string
  isVerifiedTick: string
  // channelId: string
  channelData: string
  cdnVODId: string
  cdnTranscode: string
  subttl: string
  isDisLike: string
  isSubscribe: string
  hlsLink: string
  categoryIds: string
  languageIds: string
  isLike: string
  subscribeStatus: string
  subscriberCount: string
  thumbnailImage: string
  awsThumbnail?: string
  isWatchList?: string
  isWatch: string
  themeColor: string
  encryptVideoUrl: string
  userWatchtime: string
  userEarning: string
  userLykCoin: string
  adl: string
  sharedImageName: string
  currency: string
  video_status: string
  isRestrictAge: string
  time_interval: number
  isMadeForKids?: string
  original_publish_date?: string
}

export const useVideoDetailsQuery = (url: string, enabled: boolean = true) => {
  const { user, _hasHydrated } = useUser()
  const { accessToken } = useToken()
  return useQuery({
    queryKey: ['video-details', { user }, url, accessToken],
    queryFn: async () => {
      if (user && accessToken) {
        const response = await makeApiRequest({
          url: '/VideoDetails/getVideoDetails_withLogin',
          method: 'POST',
          sendCredentials: true,
          isAuthenticated: true,
          data: {
            encryptVideoId: url,
          },
          fallbackError: 'noFallback',
          isV3Api: true
        })
      if (response?.message === "error/video-not-found") {
          throw new Error('Failed to fetch video details')

        } else if (response?.message === "error/geolocation-restricted") {
          throw new Error(JSON.stringify(response))
        }
        const videoDetails = response?.response?.data?.[0]
        if (!videoDetails) {
          throw new Error('Failed to fetch video details')
        }
        return videoDetails as VideoDetailsDto
      } else {
        const response = await makeApiRequest({
          url: '/VideoDetails/getVideoDetails_withoutLogin',
          method: 'POST',
          isAuthenticated: false,
          data: {
            encryptVideoId: url,
          },
          fallbackError: 'noFallback',
          isV3Api: true
        })
        if (response?.message === "error/video-not-found") {
          throw new Error('Failed to fetch video details')

        } else if (response?.message === "error/geolocation-restricted") {
           throw new Error(JSON.stringify(response))
        }
        const videoDetails = response?.response?.data?.[0]
        if (!videoDetails) {
          throw new Error('Failed to fetch video details')
        }
        return videoDetails as VideoDetailsDto
      }
    },
    refetchOnWindowFocus: false,
    retry: false,
    enabled: enabled && (!user || !!accessToken) && _hasHydrated ,
  })
}